@use "variables" as *;

ul {
  padding: 0;
}

.mainList {
  width: 100%;
  height: 100%;
  overflow: auto;
}

.title {
  font-size: $fontSize-m;
  font-weight: bold;
}

.listCard {
  border-radius: 16px !important;
  margin: $spacing-m;
}

.listCardWide {
  border-radius: 16px !important;
  margin: $spacing-m 0 $spacing-m $spacing-m;
}

.listItem {
  padding-left: $spacing-m !important;
  padding-right: $spacing-m !important;
}
